"use strict";

export const formatCurrency_ = (locale, currency, number) =>
  new Intl.NumberFormat(locale, { style: "currency", currency }).format(number);
